import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest, queryClient } from '@frontend/api';

import {
  getManagedIntegrationDetailsKey,
  getManagedIntegrationListKey,
} from '../keys';
import { ManagedIntegration } from '../types';

export const useCreateFusionIntegration: MutationFunction<
  ManagedIntegration,
  null
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: () => {
      return request(`/integrations/fusion/create`, {
        query,
        init: { method: 'POST' },
      });
    },
    ...queryOptions,
    mutationKey: ['createFusionIntegration'],
    onSuccess: (data, requestBody, ...rest) => {
      const key = getManagedIntegrationDetailsKey(data.uuid);
      queryClient.setQueryData(key, data);
      queryClient.invalidateQueries({
        queryKey: getManagedIntegrationListKey(),
      });
      queryOptions?.onSuccess?.(data, requestBody, ...rest);
    },
  });
};
